import { TypedStorage } from '@/utils/TypedStorage';

const legacyGetToken = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return TypedStorage.get('viewer_jwt') ?? undefined;
};

/**
 * Logs out a BYO anonymous participant by dropping the legacy `viewer_jwt`. BYO
 * tokens only live on that localStorage path (no Kinde, no refresh), so clearing
 * it fully ends the anon session.
 */
export const clearAnonymousParticipantToken = () => {
  TypedStorage.remove('viewer_jwt');
};

/**
 * Global auth configuration mutated at runtime by `AuthProvider` / `SetUpKinde`
 * once the Kinde browser client is ready, and by `ParentAuthTokenProvider` when
 * embedded. Default is the legacy localStorage path (no refresh available);
 * `AuthProvider` swaps in Kinde-backed implementations that auto-refresh.
 */
export const AUTH_CONFIG: {
  getToken: () => string | undefined | null;
  /**
   * Forces a Kinde token refresh and returns the fresh token. Undefined when
   * the legacy `viewer_jwt` localStorage path is in use, so `refreshAuth`
   * becomes a no-op there.
   *
   * Note the legacy path carries two token kinds (both set from `?userToken`):
   * impersonation tokens (have an `impersonated_by` claim) and plain
   * embedded-webview tokens. Impersonation tokens *can* be refreshed via the
   * `exchangeImpersonationToken` mutation (it requires `impersonated_by` and a
   * `teamId`), but that isn't wired up here — it's staff-only/low-volume and
   * out of scope here. Embedded tokens are refreshed by asking the embedding
   * participant app for a replacement (`ParentAuthTokenProvider`).
   */
  refreshToken?: () => Promise<string | undefined>;
} = {
  getToken: () => {
    return legacyGetToken();
  },
};
